const dev = [
  { // 攻击预警
    path: '/atteckWarn',
    name: 'atteckWarn',
    component: () => import(/* webpackChunkName: "AttackWarning" */ '../views/dev/AttackWarning.vue'),
  },
  { // 我的产品
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "myProduct" */ '../views/products/Products.vue'),
  },
  {
    path: '/products/:pid/settings/:category',
    name: 'product_settings',
    component: () => import('../views/products/ProductSettings.vue')      
  },
  {
    path: '/products/:pid/static',
    name: 'product_static',
    component: () => import('../views/products/ProductStatic.vue')      
  },
  // { // 我的产品
  //   path: '/myProduct2',
  //   name: 'myProduct2',
  //   component: () => import(/* webpackChunkName: "myProduct" */ '../views/dev/MyProduct.000.vue'),
  // },
  { // 全部域名
    path: '/allDomain',
    name: 'allDomain',
    component: () => import(/* webpackChunkName: "allDomain" */ '../views/dev/AllDomain.vue'),
  },
  { // 域名Settings
    path: '/allDomain/:id/settings',
    name: 'domain_settings',
    component: () => import('../views/domain/Settings.vue'),
  },
  { // 域名static
    path: '/allDomain/:id/static',
    name: 'domain_static',
    component: () => import('../views/domain/DomainStatic.vue'),
  },
  { // 子域名
    path: '/allDomain/:id/subdomains',
    name: 'subdomains',
    component: () => import('../views/domain/Subdomains.vue'),
  },
  { // 子域名 settings
    path: '/allDomain/:id/subdomains/:sid/settings',
    name: 'subdomain_settings',
    component: () => import('../views/domain/SubdomainSettings.vue'),
  },
  { // 子域名 static
    path: '/allDomain/:id/subdomains/:sid/static',
    name: 'subdomain_static',
    component: () => import('../views/domain/SubdomainStatic.vue'),
  },
  { // 子域名 cert
    path: '/allDomain/:id/subdomains/:sid/cert',
    name: 'subdomain_settings_cert',
    component: () => import('../views/domain/SubdomainSettingsCert.vue'),
  },
  { // 证书管理
    path: '/certManage',
    name: 'certManage',
    component: () => import(/* webpackChunkName: "certManage" */ '../views/dev/CertManage.vue'),
  },
  { // 操作日志
    path: '/handleLog',
    name: 'handleLog',
    component: () => import(/* webpackChunkName: "handleLog" */ '../views/dev/HandleLog.vue'),
  },
  { // 登录日志
    path: '/loginLog',
    name: 'loginLog',
    component: () => import(/* webpackChunkName: "loginLog" */ '../views/dev/LoginLog.vue'),
  },
  { // 登录日志
    path: '/googleCheck',
    name: 'googleCheck',
    component: () => import(/* webpackChunkName: "googleCheck" */ '../views/dev/googleCheck.vue'),
  },
];

export default dev;
